import { makeStyles } from '~styles';
import { GridLayoutItemProps } from './item.types';
import { transformSpacingProps } from '~utils';

export const useItemStyles = makeStyles<GridLayoutItemProps>()(({ spacing }, props) => {
	return {
		root: typeof props === 'object' && props !== null ? transformSpacingProps(props, spacing) : {},
	};
});
